function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M11.13 96.462h489.739v319.076H11.13z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M246.342 363.726c-2.333-1.999-57.125-49.632-57.125-107.731s54.792-105.732 57.125-107.731l9.658-8.279 9.658 8.279c2.333 1.999 57.125 49.632 57.125 107.731s-54.792 105.732-57.125 107.731L256 372.005l-9.658-8.279z",
  fill: "#d80027"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M307.942 255.994c0-51.942-51.942-96.464-51.942-96.464s-51.942 44.524-51.942 96.464c0 15.89 4.865 31.083 11.613 44.522h80.658c6.748-13.439 11.613-28.632 11.613-44.522z",
  fill: "#338af3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M307.942 255.994c0 15.89-4.865 31.083-11.613 44.522L256 307.937l-40.329-7.421c-6.748-13.439-11.613-28.632-11.613-44.522h103.884z",
  fill: "#0052b4"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M256 352.459s25.019-21.452 40.329-51.942h-80.658c15.31 30.49 40.329 51.942 40.329 51.942z",
  fill: "#ffda44"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M222.609 226.313h66.782L256 259.704z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#a2001d",
  d: "M244.87 248.57h22.261v66.783H244.87z"
});

const SvgGuam = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGuam, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/guam.9ad215b6.svg";
export { ForwardRef as ReactComponent };